<template lang="html">
  <svg class="icon blog" viewBox="0 0 24 24">
    <path
      d="M5.1,3.9h13.9c0.6,0,1.2,0.5,1.2,1.2v13.9c0,0.6-0.5,1.2-1.2,1.2H5.1c-0.6,0-1.2-0.5-1.2-1.2V5.1
          C3.9,4.4,4.4,3.9,5.1,3.9z"
    />
    <path d="M4.2,9.3h15.6" />
    <path d="M9.1,9.5v10.3" />
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.menu__item.router-link-active .icon {
  &.blog {
    animation: strokeBlog 1.5s reverse;
  }
  @keyframes strokeBlog {
    100% {
      stroke-dashoffset: 400;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/MobileNavbar/svgs/SvgBlog.vue